// import useMarketo from 'hooks/useMarketo';

import { useState } from 'react';
import api from 'services/api';
import SubmissionImg from 'assets/img/submission.webp';
import PerfectScrollbar from 'react-perfect-scrollbar';

interface ISurvey {
  videoId?: string;
  viewer: any;
  customQuestion: any;
  topSectionHeight?: number;
}

function Survey({ videoId, viewer, customQuestion, topSectionHeight }: ISurvey) {
  const [formData, setFormData] = useState({
    qualificationQuestion1: '',
    qualificationQuestion2: '',
    qualificationComment: ''
  });
  const [success, onSuccess] = useState(false);
  const [inputData, setInputData] = useState({
    qualificationQuestion1: false,
    qualificationQuestion2: false,
    qualificationComment: false
  });
  // useMarketo({
  //   formId: '1272',
  //   callback: (form: any) => {
  //     form.addHiddenFields({ Email: true });
  //     form.vals({ Email: 'songyicheng318@gmail.com', FirstName: 'Song', LastName: 'YiCheng' });
  //     window.MktoForms2.lightbox(form).show();
  //   }
  // });
  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value
    }));
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    api
      .post(`api/videos/${videoId}/external-survey/`, {
        qualificationQuestion1: [
          { qualificationQuestion1: customQuestion.question, answer: formData.qualificationQuestion1 }
        ],
        qualificationQuestion2: [
          { qualificationQuestion2: 'How can our sales team help you?', answer: formData.qualificationQuestion2 }
        ],
        qualificationComment: [{ qualificationComment: 'Anything else?', answer: formData.qualificationComment }],
        viewer
      })
      .then(() => {
        onSuccess(true);
      });
  };

  return (
    <div className={`p-4 ${topSectionHeight ? '' : 'border mr-3'} h-auto rounded-md text-black text-sm`}>
      <PerfectScrollbar
        style={{ maxHeight: topSectionHeight ? `calc(100vh - ${topSectionHeight + 120}px)` : `calc(100vh - 120px)` }}
        options={{ suppressScrollY: false, suppressScrollX: true }}
      >
        {success ? (
          <>
            <div className="h-80 overflow-hidden">
              <img src={SubmissionImg} alt="webp" />
            </div>
            <p className="mt-5 text-lg font-semibold text-center">Thank you, {viewer?.first_name}!</p>
            <p className="mt-2 text-center">Our sales team is excited to talk with you. You’ll hear from us soon.</p>
          </>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-2 gap-4">
              <fieldset className="mt-0">
                <label className="block font-medium mb-2" htmlFor="qualificationQuestion1">
                  {customQuestion.question}
                </label>
                <select
                  className="border border-gray-300 rounded-md px-3 py-2 w-full mb-2"
                  data-value-missing="Please select a company size."
                  id="qualificationQuestion1"
                  name="qualificationQuestion1"
                  required
                  onChange={handleInputChange}
                  onBlur={() =>
                    setInputData((prevInputData) => ({
                      ...prevInputData,
                      qualificationQuestion1: true
                    }))
                  }
                >
                  <option disabled selected value="">
                    Please select one
                  </option>
                  {customQuestion.choices?.map((choice: any, index: number) => (
                    <option value={choice} key={index}>
                      {choice}
                    </option>
                  ))}
                </select>
              </fieldset>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <fieldset className="mt-2">
                <label className="block font-medium mb-2" htmlFor="qualificationQuestion2">
                  How can our sales team help you?<span className="text-red-500"> *</span>
                </label>
                <select
                  className="border border-gray-300 rounded-md px-3 py-2 w-full mb-2"
                  data-value-missing="Please select a option."
                  id="qualificationQuestion2"
                  name="qualificationQuestion2"
                  required
                  onChange={handleInputChange}
                  onBlur={() =>
                    setInputData((prevInputData) => ({
                      ...prevInputData,
                      qualificationQuestion2: true
                    }))
                  }
                >
                  <option disabled selected value="">
                    Please select one
                  </option>
                  <option value="I want to book a meeting">I want to book a meeting</option>
                  <option value="I want to see a demo">I want to see a demo</option>
                  <option value="I want to understand which product is right for our organization">
                    I want to understand which product is right for our organization
                  </option>
                  <option value="I have a product question">I have a product question</option>
                  <option value="I would like to discuss pricing">I would like to discuss pricing</option>
                </select>
                {inputData['qualificationQuestion2'] && formData['qualificationQuestion2'].trim() === '' && (
                  <div className="text-red-500 mt-1 mb-2" aria-live="polite">
                    Please select one.
                  </div>
                )}
              </fieldset>
            </div>
            <fieldset className="mt-2">
              <label className="block font-medium mb-2" htmlFor="qualificationComment">
                Anything else?<span className="font-normal"> (optional)</span>
                <span className="counter" id="qualificationComment_counter">
                  <span className="count_remaining"></span>
                </span>
              </label>
              <textarea
                className="border border-gray-300 rounded-md px-3 py-2 w-full mb-2"
                id="qualificationComment"
                name="qualificationComment"
                placeholder="What challenges are you looking to overcome?"
                spellCheck="false"
                onChange={handleInputChange}
              ></textarea>
            </fieldset>

            <div className="container mx-auto">
              <div className="text-sm text-red-500">
                <div className="mb-4">
                  <span className="mr-1">*</span> Fields marked with an asterisk (*) are required.
                </div>
              </div>
            </div>
            <button
              className="bg-red-main hover:bg-red-main text-white font-bold py-3 px-12 rounded focus:outline-none focus:shadow-outline"
              type="submit"
            >
              Submit
            </button>
          </form>
        )}
      </PerfectScrollbar>
    </div>
  );
}

export default Survey;
